<template>
  <page>
    <div>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
          <div class="headline">Cargo Conveyance Listing</div>
          <v-spacer></v-spacer>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-card-title>
        <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
          <template slot="headerCell" slot-scope="props">
            <v-tooltip bottom>
              <span slot="activator">
                {{ props.header.text }}
              </span>
              <span>
                {{ props.header.text }}
              </span>
            </v-tooltip>
          </template>
          <template slot="items" slot-scope="props">
            <td>{{ props.item.convy }}</td>
            <td class="text-xs-left">{{ props.item.convyDesc }}</td>
            <td class="text-xs-right">
              <table-action :rowData="props" :review="checkAccess(['cargoRatingReview'])" @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <div class="pt-2">
        <v-btn color="primary" @click.native="doNew()">
          New Conveyance
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
      <v-dialog v-model="convyDialog" width="800px" lazy v-if="checkAccess(['cargoRatingReview'])" persistent >
        <conveyance-dialog :convyForm="convyForm" @close="doClose" :newConvy="newConvy"></conveyance-dialog>
      </v-dialog>
      <confirm v-model="promptRemove" @ok="doRemove">
          Are you sure that you want to delete the selected Cargo Conveyance? ({{deleteCrgoConvy}})
      </confirm>
    </div>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import ConveyanceDialog from './ConveyanceDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Cargo Conveyance', align: 'left', value: 'convy' },
        { text: 'Cargo Conveyance Description', align: 'left', value: 'convyDesc' }
      ],
      convyForm: {
        convy: undefined,
        convyDesc: undefined
      },
      convyDialog: undefined,
      newConvy: undefined,
      loading: false,
      promptRemove: false,
      selectedCrgoConvy: undefined,
      deleteCrgoConvy: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async fetchData() {
      this.loading = true
      const apiUrl = this.$store.state.cargo.menu.getCrgoConvys
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((CrgoConvy) => {
              const convertCrgoConvy = {
                convy: CrgoConvy.convy,
                convyDesc: CrgoConvy.convyDesc
              }
              this.items.push(convertCrgoConvy)
            })
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      }
    },
    async doReview(Convy) {
      const apiURI = this.$store.state.cargo.menu.getCrgoConvy
      const expand = {
        convy: Convy.item.convy
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.convyForm.convy = data.convy.convy
          this.convyForm.convyDesc = data.convy.convyDesc
        }
        this.convyDialog = true
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedCrgoConvy = data
        this.deleteCrgoConvy = data.convy + ' - ' + data.convyDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.cargo.menu.deleteConvy
      if (apiURI) {
        this.loading = true
        const expand = {
          convy: this.selectedCrgoConvy.convy
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClose() {
      this.convyDialog = false
      this.newConvy = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.convyDialog = true
      this.newConvy = true
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData()
  },
  created() {
    if (this.checkAccess(['cargoRatingReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    ConveyanceDialog: ConveyanceDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>

</style>
